// extracted by mini-css-extract-plugin
export var lg = "_j-7";
export var md = "_j-6";
export var placeholderContainer = "_j-1";
export var placeholderIcon = "_j-2";
export var productImage = "_j-0";
export var sm = "_j-5";
export var xl = "_j-8";
export var xs = "_j-4";
export var xxs = "_j-3";